export default {
    auth: {
        student: [
            {
                icon: 'mdi-home-outline',
                activeIcon: 'mdi-home',
                name: 'home',
                text: 'Home',
                to: {name: 'home'},
            },
            {
                icon: 'mdi-school-outline', /* school */
                activeIcon: 'mdi-school',
                name: 'courses',
                text: 'Courses',
                to: {name: 'courses'}
            },
            {
                icon: 'mdi-school-outline', /* book-open-variant-outline */
                activeIcon: 'mdi-school',
                name: 'programs',
                text: 'Group Classes',
                to: {name: 'programs'}
            },
            {
                icon: 'mdi-inbox-full',
                activeIcon: 'mdi-inbox-full',
                name: 'inbox',
                text: 'Inbox',
                to: {name: 'inbox'},
                chip: 'unreadInboxCount',
            },
            {
                icon: 'mdi-calendar-month-outline', /* school */
                activeIcon: 'mdi-calendar-month',
                name: 'calendar',
                text: 'Calendar',
                to: {name: 'calendar'}
            },
            {
                icon: 'mdi-view-day-outline', /* school */
                activeIcon: 'mdi-view-day',
                name: 'my-courses',
                text: 'My Courses',
                to: {name: 'my-courses'}
            },
            {
                icon: 'mdi-wallet-outline',
                activeIcon: 'mdi-wallet',
                name: 'wallet',
                text: 'Wallet',
                to: {name: 'wallet'},
                hide: 'walletDisabled'
            },
            {
                icon: 'mdi-file-account-outline',
                activeIcon: 'mdi-file-account',
                name: 'class-reports',
                text: 'Class Reports',
                to: {name: 'class-reports'}
            },
            /* {
                icon: 'mdi-information-outline',
                activeIcon: 'mdi-information',
                name: 'about',
                text: 'About Us',
                href: process.env.VUE_APP_WELCOME_WEBSITE_URL
            }, */
            {
                icon: 'mdi-lifebuoy',
                name: 'help',
                text: 'Help',
                to: {name: 'help'}
            },
            {
                icon: 'mdi-text',
                name: 'terms',
                text: 'Terms And Conditions',
                to: {name: 'terms'}
            },
            {
                icon: 'mdi-cog-outline',
                activeIcon: 'mdi-cog',
                name: 'settings',
                text: 'Settings',
                to: {name: 'settings'}
            }
        ],
        teacher: [
            {
                icon: 'mdi-home-outline',
                activeIcon: 'mdi-home',
                name: 'home',
                text: 'Home',
                to: {name: 'home'}
            },
            {
                icon: 'mdi-inbox-full',
                activeIcon: 'mdi-inbox-full',
                name: 'inbox',
                text: 'Inbox',
                to: {name: 'inbox'},
                chip: 'unreadInboxCount',
            },
            {
                icon: 'mdi-calendar-month-outline', /* school */
                activeIcon: 'mdi-calendar-month',
                name: 'calendar',
                text: 'Classes Calendar',
                to: {name: 'calendar'}
            },
            {
                icon: 'mdi-account-group-outline',
                activeIcon: 'mdi-account-group',
                name: 'my-students',
                text: 'My Students',
                to: {name: 'my-students'}
            },
            {
                icon: 'mdi-file-account-outline',
                activeIcon: 'mdi-file-account',
                name: 'class-reports',
                text: 'Class Reports',
                to: {name: 'class-reports'}
            },
            {
                icon: 'mdi-cash-multiple',
                activeIcon: 'mdi-cash-multiple',
                name: 'salary-report',
                text: 'Salary Report',
                hide: 'walletDisabled',
                to: {name: 'salary-report'}
            },
            {
                icon: 'mdi-cash-multiple',
                activeIcon: 'mdi-cash-multiple',
                name: 'previous-salary',
                text: 'Previous Salary',
                hide: 'walletDisabled',
                to: {name: 'previous-salary'}
            },
            {
                icon: 'mdi-table-clock',
                activeIcon: 'mdi-table-clock',
                name: 'time-table',
                text: 'Time Table',
                to: {name: 'time-table'}
            },
            {
                icon: 'mdi-help',
                name: 'help',
                text: 'Help',
                to: {name: 'help'}
            },
            {
                icon: 'mdi-cog-outline',
                activeIcon: 'mdi-cog',
                name: 'settings',
                text: 'Settings',
                to: {name: 'settings'}
            }
        ]
    },
    guest: [
        /* {
            icon: 'mdi-home-outline',
            name: 'Home',
            to: {name: 'welcome'}
        }, */
        {
            icon: 'mdi-account-plus-outline',
            name: 'Sign Up',
            to: {name: 'register'}
        },
        {
            icon: 'mdi-login-variant',
            name: 'Sign In',
            to: {name: 'login'}
        },
        {
            icon: 'mdi-information-outline',
            name: 'About Us',
            href: process.env.VUE_APP_WELCOME_WEBSITE_URL
        },
        {
            icon: 'mdi-help',
            name: 'Help',
            to: {name: 'help'}
        }
    ]
}